import type { CreateSecret } from "@/app/secrets/types";
import type { ApiClient } from "@/lib/api";

export const createSecret = async (options: {
  client: ApiClient;
  secret: CreateSecret;
}) => {
  const { client, secret } = options;
  const { key, value, description } = secret;
  const payload = { value, description };

  const { data } = await client.put(`/secrets/${key}`, payload);
  return data;
};
